
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.13 8.862v-3.5a2.99 2.99 0 01-.935 0v3.5a4.244 4.244 0 01.935 0zM6.96 10.422l3.467-3.467a3.002 3.002 0 01-.662-.662L6.3 9.76a4.293 4.293 0 01.661.662zM11.393 12.59H7.858a4.294 4.294 0 010 .936h3.535a2.993 2.993 0 010-.936zM3.662 4.463a2.043 2.043 0 100-4.086 2.043 2.043 0 000 4.086zM12.175 6.588a2.043 2.043 0 100-4.086 2.043 2.043 0 000 4.086zM14.334 15.1a2.043 2.043 0 100-4.085 2.043 2.043 0 000 4.085zM6.948 13.058c0-.878-.341-1.703-.962-2.324a3.263 3.263 0 00-2.323-.962 3.29 3.29 0 00-3.287 3.286 3.29 3.29 0 003.287 3.286 3.29 3.29 0 003.285-3.286z"}})])
          )
        }
      }
    